module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-SPORT-2.efe382f0.jpg";